export default {
  API_KEY: process.env.REACT_APP_API_KEY,
  API_ENDPOINT: 'https://aqueous-retreat-24827.herokuapp.com/api',
  TOKEN_KEY: process.env.TOKEN_KEY
}